import { sanitizeGraphQLErrors, showErrors } from 'helpers/errors'

export const contactRequestEventPayload = ({
  ticketNumber,
  provider: {
    type,
    address: {
      city,
    },
  },
  eventCategory,
}) => ({
  event: 'addToCart',
  requestId: ticketNumber,
  eventCategoryName: eventCategory.displayName,
  city: city.name,
  providerType: type,
})

export const sanitizeFormValues = (values) => {
  const sanitizedValues = { ...values }

  if (values.requestedDates !== undefined) {
    let requestedDates = sanitizedValues.requestedDates || []

    if (!Array.isArray(requestedDates)) {
      requestedDates = [requestedDates]
    }

    sanitizedValues.requestedDates = requestedDates.map((date) => date.format())
  }

  sanitizedValues.projectId = undefined

  return sanitizedValues
}

export const showSanitizedErrors = (errors, intl) => {
  showErrors(
    sanitizeGraphQLErrors(
      errors,
      {
        messageCallback: (field) => field.messages.join('<br />'),
      },
    ) || intl.formatMessage({ id: 'common.genericRequestError' }),
  )
}
